<script>
    import { scale } from "svelte/transition";
    import l from "./utils/locale";
    export let name = "";
</script>

<div id={name} class="app-menu-wrapper" transition:scale={{ duration: 300 }}>
    <slot />
</div>
